module.exports = __webpack_public_path__ + "media/caspr_mockup.e28a7651.mp4";